import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { Url } from '../../url/url'

export const maincategorydata = createAsyncThunk(
    'maincategory/maincategorydata',
    async () => {
        const res = await axios.get(`${Url}/api/maincategory/all`)
        return res.data
    }
)

const mainCategorySlice = createSlice({
    name: 'maincategory',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(maincategorydata.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(maincategorydata.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload
            })
            .addCase(maincategorydata.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message
            })
    }
})

export default mainCategorySlice.reducer